const translationEn = {
  "frontpage-hero-h1": "Payment <br />Solutions for<br />Everyone",
};

export default translationEn;
